import React from  'react';
import ChangePasswordForm from '../../../smart/forms/login/ChangePasswordForm';

const ChangePasswordPage = (props) => {
    return(
        <ChangePasswordForm data={props}/>
    )
}

export default ChangePasswordPage